import { StoryPage } from './StoryPage'
import { withStoryPage } from './withStoryPage'

const Connected = withStoryPage(StoryPage)

export { Connected as StoryPage }
